import React from 'react';
import { useIntl } from 'react-intl';
import Select from 'react-select';

import PropTypes from 'prop-types';

// import classes from '@/components/OrdersReportsModal/style.module.scss';

const MultipleSelect = ({ placeholder, options, field, form, ...props }) => {
  const intl = useIntl();

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '34px',
      borderColor: state.isFocused ? '#4d8fca' : '#e3e3e3',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#4d8fca',
      },
      fontSize: '12px',
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: '12px',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#4d8fca' : state.isFocused ? '#f5f5f5' : '#ffffff',
      color: state.isSelected ? '#ffffff' : '#919191',
      fontSize: '12px',
      fontWeight: '500',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: state.isSelected ? '#4d8fca' : '#f5f5f5',
      },
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: provided => ({
      ...provided,
      color: '#b1b1b1',
      padding: '6px',
    }),
    multiValue: (base) => ({
      ...base,
      borderRadius: '15px',
      backgroundColor: '#658ec6',
      color: '#ffffff',
    }),
    multiValueLabel: (base) => ({
      ...base,
      padding: '2px 2px 2px 8px',
      fontSize: '12px',
      color: '#ffffff',
    }),
    multiValueRemove: (base) => ({
      ...base,
      borderRadius: '0 13px 13px 0',
      padding: '2px 5px 2px 2px',
      backgroundColor: '#658ec6',
      color: '#ffffff',
      '&:hover': {
        backgroundColor: '#4a6fa5', // darkened #658ec6
        color: '#ffffff',
      },
    }),
  };

  return (
    <Select
      className="w-full"
      classNamePrefix="select"
      styles={selectStyles}
      name={field.name}
      value={field.value}
      placeholder={placeholder}
      options={options}
      noOptionsMessage={() => intl.formatMessage({ id: 'NO_SELECT_OPTIONS' })}
      onChange={values => form.setFieldValue(field.name, values || [])}
      onBlur={field.onBlur}
      isMulti
      isClearable
      closeMenuOnSelect
      {...props}
    />
  );
};

MultipleSelect.propTypes = {
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};

export default MultipleSelect;
